import * as Types from '../../../../generated/webapp_gql';

import { gql } from 'graphql.macro';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type ClientSelectQueryVariables = Types.Exact<{
  search?: Types.Maybe<Types.Scalars['String']>;
}>;


export type ClientSelectQuery = (
  { __typename?: 'Query' }
  & { clients?: Types.Maybe<(
    { __typename?: 'ClientSummaryNodeConnection' }
    & { edges: Array<Types.Maybe<(
      { __typename?: 'ClientSummaryNodeEdge' }
      & { node?: Types.Maybe<(
        { __typename?: 'ClientSummaryNode' }
        & Pick<Types.ClientSummaryNode, 'appInstalled' | 'companyName' | 'id' | 'isCompanyHpiEnabled' | 'memberEmail' | 'memberFirstName' | 'memberInsuranceStatus' | 'memberLastName' | 'memberName' | 'memberUuid' | 'visitsCovered' | 'visitsRemaining' | 'visitsUsed'>
        & { coachAssignment?: Types.Maybe<(
          { __typename?: 'CoachAssignmentNode' }
          & Pick<Types.CoachAssignmentNode, 'uuid' | 'active' | 'createdAt'>
          & { coachingVisits: Array<(
            { __typename?: 'CoachingVisitNode' }
            & Pick<Types.CoachingVisitNode, 'uuid' | 'isTherapy' | 'scheduledTime' | 'modalityType' | 'scheduledDuration' | 'actualDuration' | 'state' | 'visitInfo' | 'organizationImprovements' | 'isPsychiatryInitialEvaluation'>
            & { previousProviderReview?: Types.Maybe<(
              { __typename?: 'CoachingVisitProviderReviewNode' }
              & Pick<Types.CoachingVisitProviderReviewNode, 'abilityToHelpClient' | 'workedOnAgreedUponGoals' | 'clearPlanToWorkTowardGoals' | 'feedbackText'>
            )> }
          )> }
        )> }
      )> }
    )>> }
  )> }
);


export const ClientSelectDocument = gql`
    query ClientSelect($search: String) {
  clients(search: $search, orderBy: "firstname") {
    edges {
      node {
        appInstalled
        companyName
        id
        isCompanyHpiEnabled
        memberEmail
        memberFirstName
        memberInsuranceStatus
        memberLastName
        memberName
        memberUuid
        visitsCovered
        visitsRemaining
        visitsUsed
        coachAssignment {
          uuid
          active
          createdAt
          coachingVisits {
            uuid
            isTherapy
            scheduledTime
            modalityType
            scheduledDuration
            actualDuration
            state
            visitInfo
            organizationImprovements
            isPsychiatryInitialEvaluation
            previousProviderReview {
              abilityToHelpClient
              workedOnAgreedUponGoals
              clearPlanToWorkTowardGoals
              feedbackText
            }
          }
        }
      }
    }
  }
}
    `;
export type ClientSelectComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ClientSelectQuery, ClientSelectQueryVariables>, 'query'>;

    export const ClientSelectComponent = (props: ClientSelectComponentProps) => (
      <ApolloReactComponents.Query<ClientSelectQuery, ClientSelectQueryVariables> query={ClientSelectDocument} {...props} />
    );
    
export type ClientSelectProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ClientSelectQuery, ClientSelectQueryVariables>
    } & TChildProps;
export function withClientSelect<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClientSelectQuery,
  ClientSelectQueryVariables,
  ClientSelectProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ClientSelectQuery, ClientSelectQueryVariables, ClientSelectProps<TChildProps, TDataName>>(ClientSelectDocument, {
      alias: 'clientSelect',
      ...operationOptions
    });
};

/**
 * __useClientSelectQuery__
 *
 * To run a query within a React component, call `useClientSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSelectQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useClientSelectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ClientSelectQuery, ClientSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ClientSelectQuery, ClientSelectQueryVariables>(ClientSelectDocument, options);
      }
export function useClientSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ClientSelectQuery, ClientSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ClientSelectQuery, ClientSelectQueryVariables>(ClientSelectDocument, options);
        }
export type ClientSelectQueryHookResult = ReturnType<typeof useClientSelectQuery>;
export type ClientSelectLazyQueryHookResult = ReturnType<typeof useClientSelectLazyQuery>;
export type ClientSelectQueryResult = ApolloReactCommon.QueryResult<ClientSelectQuery, ClientSelectQueryVariables>;